// TEAM MEMBER LIST
    const memberList = [
    { name: "memberKaushik.jpeg", title: "CarGenie", 
        memberDetails : 
        [
            { name: " Koushik Banerjee", 
                role: "Insurance Head & Service Advisor", 
                experience: "25+ Years", 
                experienceDesc: "Mahindra, Maruti Suzuki, Hyundai, Mohon Motors", 
                education: "Jadavpur University | Certified by Major Car Manufacturers",
                summary: "A true all-rounder, Koushik Banerjee leads Car Genie’s insurance and service operations with unmatched efficiency. With a proven record of zero-claim failures and lightning-fast processing, he ensures every customer gets their vehicle back without hassle. Beyond insurance, his strong background in mechanical systems and bodyshop management enables him to offer transparent, expert guidance. Koushik’s sharp knowledge, customer-first approach, and technical depth make him one of the most trusted advisors in Kolkata’s automobile service industry." 
            }
        ] 
    },
    { name: "memberRamesh.jpeg", title: "CarGenie",
        memberDetails : 
        [
            { name: "Ramesh Sharma", 
                role: "Mechanical Lead", 
                experience: "15+ Years", 
                experienceDesc: "Maruti Suzuki, Bosch, Mahindra", 
                summary: "Ramesh Sharma is a seasoned mechanical engineer with over 15 years of experience in the automotive industry. Having worked with renowned companies like Maruti Suzuki, Bosch, and Mahindra, Ramesh brings a wealth of knowledge and expertise to CarGenie. His deep understanding of vehicle mechanics and commitment to excellence ensure that every car serviced under his supervision meets the highest standards of quality and performance." 
            }
        ]
     },
    { name: "memberMadhab.jpeg", title: "CarGenie",
        memberDetails : 
        [
            { name: "Madhab Das", 
                role: "Senior Paint Specialist", 
                experience: "17+ Years", 
                experienceDesc: "Maruti Suzuki, Toyota, Hyundai, Palki", 
                summary: "When it comes to paint perfection, Madhab Das is a name trusted by hundreds of car owners across Kolkata. With 17+ years of experience, he specializes in heat chamber painting, solvent and water-based systems, and flawless color matching. Whether it’s restoring the factory finish or achieving custom shades, Madhab’s keen eye for detail and mastery over surface prep make every car look brand new. He’s the artist behind Car Genie’s mirror-finish transformations."
            }
        ]
     },
    { name: "memberNirapada.jpeg", title: "CarGenie",
        memberDetails : 
        [
            { name: "Nirapada Ghorui", 
                role: "Bodyshop Master Technician ", 
                experience: "27+ Years", 
                experienceDesc: "Accident Repairs, Rust Restoration, MIG & Spot Welding", 
                summary: "With nearly three decades of experience, Nirapada Ghorui is a true craftsman of metal. His ability to reshape and restore accident-damaged cars to their original form has earned him immense respect in the industry. From major collision repairs to rust treatment and panel perfection, Nirapada ensures every car regains its original integrity and strength. His craftsmanship defines the trust Car Genie’s customers have in our bodyshop division." 
            }
        ]
     }
]

export default memberList;